import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[tpTrimOnBlur]'
})
export class TrimOnBlurDirective {
  @HostListener('blur', ['$event.target', '$event.target.value'])
  onblur(el: any, value: string): void {
    const trimmedValue = value.trim();

    if (el.value === trimmedValue) {
      return;
    }

    el.value = trimmedValue;

    this.dispatchEvent(el, 'input');
    this.dispatchEvent(el, 'blur'); // in case updateOn is set to blur
  }

  dispatchEvent(el: any, eventType: string): void {
    const event = document.createEvent('Event');
    event.initEvent(eventType, false, false);
    el.dispatchEvent(event);
  }
}
